export default __webpack_public_path__ + "static/media/ryzen1600.8f3d6103.jpg";